// Small, locale-aware formatting helpers used across the dashboard.

export function formatNumber(value: number, maximumFractionDigits = 0): string {
  return new Intl.NumberFormat('en-US', { maximumFractionDigits }).format(value);
}

export function formatCurrency(value: number, currency = 'USD'): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(value);
}

/**
 * Format a ratio (0..1) as a percentage. Pass `alreadyPercent` when the value
 * is already on a 0..100 scale.
 */
export function formatPercent(value: number, digits = 1, alreadyPercent = false): string {
  const pct = alreadyPercent ? value : value * 100;
  return `${pct.toFixed(digits)}%`;
}

export function formatDate(value: string | null): string {
  if (!value) return '—';
  const d = new Date(value.includes('T') ? value : value.replace(' ', 'T') + 'Z');
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}

export function titleCase(value: string): string {
  return value
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Tailwind classes for a status badge, keyed by common status strings. */
export function statusBadgeClass(status: string): string {
  switch (status) {
    case 'active':
    case 'operational':
    case 'delivered':
      return 'bg-emerald-100 text-emerald-700';
    case 'probation':
    case 'maintenance':
    case 'in_transit':
    case 'planned':
      return 'bg-amber-100 text-amber-700';
    case 'suspended':
    case 'offline':
    case 'delayed':
    case 'cancelled':
      return 'bg-rose-100 text-rose-700';
    default:
      return 'bg-slate-100 text-slate-600';
  }
}
